<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Callum Andrew McGhee is an extremely descriptive up-and-coming poet and author. He resides in Johannesburg, South Africa. His inspiration is gained through looking differently at the world around him and from his own experiences. Although an autobiographical author, his imagination is someday going to make him a successful fictional writer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?73cce934